import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface CommunitySegmentConfirmationCardProps {
  people_count?: number;
  title?: string;
}

export const CommunitySegmentConfirmationCard = ({
  title,
  people_count,
}: CommunitySegmentConfirmationCardProps) => {
  const peopleText =
    people_count != null
      ? t("help_widget.copilot.confirmation_card.people_count", {
          count: people_count,
        })
      : undefined;

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.segment_title")}
      attributes={[
        {
          label: t("help_widget.copilot.confirmation_card.name"),
          value: title,
        },
        {
          label: t("help_widget.copilot.confirmation_card.people"),
          value: peopleText,
        },
      ]}
    />
  );
};
